import React, { Component } from 'react'
import PropTypes from 'prop-types'

import Select, { Creatable } from 'react-select'

class SelectForm extends Component {
  constructor(props) {
    super(props)

    this.state = {
      itemSelectorValue: '',
      itemSelectorIsLoading: false,
      selectedItem: undefined,
      itemGroupChild: {},
      showItemGrouping: false,
      typeSelectorValue: '',
      showTypeSelector: false,
      searchInputTimeout: null
    }

    this.selector = React.createRef()
    this.hiddenInput = React.createRef()
    this.typeSelector = React.createRef()
    this.groupingButton = React.createRef()
  }

  componentWillMount() {
    const { options, categories, searchResults } = this.props

    if (searchResults === undefined && (options || categories)) this.getInitialSearchResults(options, categories, searchResults)
  }

  componentWillReceiveProps(nextProps) {
    const { options, categories, searchResults } = nextProps

    if (searchResults === undefined && ((options && this.props.options === undefined) || (categories && this.props.categories === undefined))) this.getInitialSearchResults(options, categories, searchResults)
  }

  shouldComponentUpdate(nextProps, nextState) {
    const { item, options, categories, searchResults } = nextProps

    if (item !== this.props.item) return true
    if (options !== this.props.options) return true
    if (categories !== this.props.categories) return true
    if (searchResults !== this.props.searchResults) return true
    if (nextState !== this.state) return true
    return false
  }

  componentWillUpdate(nextProps, nextState) {
    const { item } = nextProps

    if (item !== this.props.item && item.id !== undefined) this.props.removeFocus()
  }

  componentWillUnmount() {
    if (this.state.searchInputTimeout) clearTimeout(this.state.searchInputTimeout)
  }

  getInitialSearchResults(options, categories, searchResults) {
    this.setState({itemSelectorIsLoading: false}, () => {
      this.props.getSearchResults(
        options && options.length > 0
        ? options
        : categories,
        this.state.itemSelectorValue
      )
    })
  }

  setSelectorFocus(selector, value, searchResults) {
    this.setState({
      itemSelectorIsLoading: searchResults === undefined ? true : false
    }, () => {
      const { select } = selector.current
      if (select) selector.current.select.handleInputChange({target: {value: (value && value.title) || ''}})
    })
  }

  clearSearchResults() {
    this.props.getSearchResults([])
  }

  clearFocus() {
    this.setState({itemGroupChild: null},
      () => this.props.removeFocus()
    )
  }

  itemIsSelected(item, value) {
    this.setState({showTypeSelector: false, showItemGrouping: false})

    if (item.id !== undefined) {
      if (!item.parent && value.type && value.type.indexOf('drum') !== -1) {
        this.suggestItemGrouping({...value, id: item.id})
      } else
      if (value.title === '') {
        this.props.deleteRiderItem(item.id)
      } else {
        this.props.editRiderItem({
          id: item.id,
          type: value.type,
          title: value.title
        })
      }
    } else {
      if (!item.parent && value.type && value.type.indexOf('drum') !== -1) {
        this.suggestItemGrouping(value)
      } else {
        this.props.createRiderItem({
          type: value.type,
          group: this.props.group,
          class: item.class,
          title: value.title,
          position: this.props.position,
          parent: item.parent,
          params: value.params || item.params
        })

        // if (item.class !== 'instrument') this.clearFocus()
        if (value.stageElementGroup) this.props.createStageElement({title: value.title, group: value.stageElementGroup})
      }
    }
  }

  createItemGroup(id, group) {
    const { itemGroupChild } = this.state

    // TODO: Replace createChildren with multi call, creating drum element from existing instruments creates a duplicate

    if (group) {
      this.props.createRiderItem({
        type: itemGroupChild.type,
        group: this.props.group,
        class: 'instrument',
        title: itemGroupChild.title,
        position: group.children.length+1,
        parent: group.id
      })
    } else
    if (id) {
      this.props.editRiderItem({
        id: id,
        type: 'drum-set',
        group: this.props.group,
        class: 'instrument-group',
        title: 'Drum set',
        position: this.props.position,
        parent: null
      })
    } else {
      this.props.createRiderItem({
        type: 'drum-set',
        group: this.props.group,
        class: 'instrument-group',
        title: 'Drum set',
        position: this.props.position,
        parent: null,
        params: {
          createChildren: itemGroupChild.type && itemGroupChild.title ? [this.state.itemGroupChild] : null
        }
      })
    }

    this.clearFocus()
  }

  suggestItemGrouping(value) {
    if (value.title === 'Drums' || value.title === 'Drumm set') {
      this.createItemGroup(value.id)
    } else {
      this.setState({
        showItemGrouping: true,
        itemGroupChild: value,
      }, () => this.groupingButton.current.focus())
    }
  }

  renderItemGrouping(itemGroups, itemGroupingText) {
    return (
      <div>
        <hr />

        <p>
          {
            !itemGroupingText
            ? `You have entered a drum element. It is advised to group those into a "Drum set"`
            : itemGroupingText
          }

          <button ref={this.groupingButton} onClick={() => this.createItemGroup()}>{!itemGroupingText ? 'Group now' : 'a new drum set'}</button>
        </p>

        {
          itemGroups.length > 0
          ? <p className="item-groups">
              {
                !itemGroupingText
                ? `Alternatively you can add it to one of your existing drum sets:`
                : `or add to existing`
              }

              {
                itemGroups.map((group, index) => <button key={index} ref={this.groupingButton} onClick={() => this.createItemGroup(null, group)}>{`drum set (ch ${group.position} - ${group.position+group.children.length})`}</button>)
              }
            </p>
          : null
        }
      </div>
    )
  }

  getValue(item, selectedItem) {
    if (selectedItem && selectedItem.title) {
      return selectedItem
    } else
    if (item.title) {
      return item
    } else {
      return undefined
    }
  }

  getOptions = (input) => {
    if (this.state.searchInputTimeout) clearTimeout(this.state.searchInputTimeout)

    const searchInputTimeout = setTimeout(() => {
      const { options, categories, searchResults } = this.props

      this.props.getSearchResults(
        options && options.length > 0
        ? options
        : categories,
        input
      )

      if (searchResults !== undefined) this.setState({itemSelectorIsLoading: false})
    }, 500)

    this.setState({itemSelectorIsLoading: input.length > 0 ? true : false, searchInputTimeout})
  }

  render() {
    const { item, itemGroups, placeholder, promptTextCreator, typeSelectorText, itemGroupingText, categories, searchResults } = this.props
    const { itemSelectorValue, itemSelectorIsLoading, selectedItem, typeSelectorValue, showTypeSelector } = this.state

    const value = this.getValue(item, selectedItem)

    const skipEntry = !itemSelectorValue || itemSelectorValue === item.title
    const enableXaxis = !itemSelectorValue
    const enableYaxis = (searchResults && searchResults.length <= 1) && showTypeSelector !== true

    return (
      <div className="select-form">
        <div className="select-form-escape" onClick={() => this.clearFocus()} />

        <div className="select-form-fields"
          onKeyDown={(e) => {
            if (
              ((e.key === 'Enter' || e.key === 'Tab') && skipEntry) ||
              ((e.key === 'ArrowLeft' || e.key === 'ArrowRight') && enableXaxis) ||
              ((e.key === 'ArrowUp' || e.key === 'ArrowDown') && enableYaxis)
            ) {
              this.props.changeFocus(e)
              this.props.removeFocus()
            } else
            if (e.key === 'Enter' || e.key === 'Tab') {
              this.props.setFocusKey(e)
            }
          }}>
          <Creatable ref={this.selector}
            cache={false}
            autoFocus={this.props.setFocus}
            openOnFocus={this.props.setFocus}
            isLoading={itemSelectorIsLoading}
            className="select-form-field"
            value={value}
            valueKey="id"
            labelKey="title"
            clearable={false}
            placeholder={placeholder ? placeholder : `Search ${item.class} by it's type or brand name`}
            searchPromptText={null}
            promptTextCreator={(label) => {
              if (value && value.title === label) return placeholder || `Add ${item.class}`
              return promptTextCreator
              ? `${promptTextCreator} "${label}"`
              : `Add custom ${item.class} "${label}"`
            }}
            onOpen={() => this.setSelectorFocus(this.selector, value, searchResults)}
            onInputKeyDown={(e) => {
              if (e.key === 'Backspace' && !itemSelectorValue) {
                if (item.id) this.props.deleteRiderItem(item.id)
                this.props.removeFocus()
              } else
              if (e.key === 'Escape') {
                this.props.removeFocus()
              }
            }}
            onInputChange={(input) => {
              this.setState({itemSelectorValue: input}, () => this.getOptions(input))

              return input
            }}
            onChange={(value) => {
              this.setState({selectedItem: value}, () => this.itemIsSelected(item, {title: (value && value.title) || '', type: item.type ? item.type.slug : value.type.slug}))

              this.clearSearchResults()
            }}
            onNewOptionClick={(value) => {
              if (item.parent && item.type) {
                this.setState({selectedItem: value}, () => {
                  this.itemIsSelected(item, {title: value.title, type: item.type.slug})
                  this.hiddenInput.current.focus() // TODO: Replace hiddenInput with unfocus
                })
              } else {
                const selectedItem = {title: value.title, type: undefined}
                this.setState({selectedItem, showTypeSelector: true}, () => this.typeSelector.current.focus())
              }
            }}
            onBlur={() => this.clearSearchResults()}
            loadingPlaceholder={null}
            noResultsText={searchResults !== undefined ? '' : 'Loading results...'}
            options={searchResults}
            filterOptions={(options, filter) => {
              return options.map(option => {
                if (option.title.toLowerCase() === filter.toLowerCase()) {
                  return {...option, title: filter}
                } else {
                  return option
                }
              })
            }} />

          <input ref={this.hiddenInput} style={{position: 'absolute', top: 0, left: 0, opacity: 0, zIndex: -1}} />

          {
            this.state.showTypeSelector
            ? <hr />
            : null
          }

          {
            this.state.showTypeSelector && !typeSelectorText
            ? <p>{`Oops, we did not recognize this ${item.class}. Can you tell us it's category?`}</p>
            : null
          }

          {
            this.state.showTypeSelector
            ? <Select ref={this.typeSelector}
                cache={false}
                openOnFocus={true}
                className="select-form-field"
                value={undefined}
                valueKey="id"
                labelKey="title"
                clearable={false}
                placeholder={typeSelectorText ? typeSelectorText : 'Select...'}
                onInputKeyDown={(e) => {
                  if (e.key === 'Enter' && !typeSelectorValue) {
                    this.itemIsSelected(item, {title: selectedItem.title, type: 'custom'})
                  }
                }}
                onChange={(value) => {
                  this.itemIsSelected(item, {title: selectedItem.title, type: value.type.slug, params: value.params, stageElementGroup: value.id})
                }}
                noResultsText={categories.length > 0 ? 'Clear field to select an existing category' : 'Loading results...'}
                options={categories} />
            : null
          }

          {/*
            this.state.showTypeSelector === true
            ? this.props.creatableCategory === true
              ? <Creatable ref={this.typeSelector} // TODO: Needs a chained API call
                  cache={false}
                  openOnFocus={true}
                  className="select-form-field"
                  value={undefined}
                  valueKey="id"
                  labelKey="title"
                  clearable={false}
                  placeholder={typeSelectorText ? typeSelectorText : 'Select category or type for new'}
                  onChange={(value) => this.itemIsSelected(item, {group: value.id, title: selectedItem.title, type: value.type.slug, params: value.params})}
                  promptTextCreator={(label) => `Add to column "${label}"`}
                  onNewOptionClick={(value) => {
                    this.props.createRiderColumn({title: value.title, type: 'custom'})
                    this.itemIsSelected(item, {title: selectedItem.title, type: value.type.slug, params: {columnId}})
                  }}
                  noResultsText={categories.length > 0 ? '' : 'Loading results...'}
                  options={categories} />
              : <Select ref={this.typeSelector}
                  cache={false}
                  openOnFocus={true}
                  className="select-form-field"
                  value={undefined}
                  valueKey="id"
                  labelKey="title"
                  clearable={false}
                  placeholder={typeSelectorText ? typeSelectorText : 'Select...'}
                  onChange={(value) => this.itemIsSelected(item, {group: value.id, title: selectedItem.title, type: value.type.slug, params: value.params})}
                  noResultsText={categories.length > 0 ? 'Clear field to select an existing category' : 'Loading results...'}
                  options={categories} />
            : null
          */}

          {
            this.state.showItemGrouping
            ? this.renderItemGrouping(itemGroups, itemGroupingText)
            : null
          }
        </div>
      </div>
    )
  }
}

SelectForm.propTypes = {
  group: PropTypes.string,
  item: PropTypes.object,
  itemGroups: PropTypes.array,
  position: PropTypes.number,
  placeholder: PropTypes.string,
  promptTextCreator: PropTypes.string,
  typeSelectorText: PropTypes.string,
  itemGroupingText: PropTypes.string,
  setFocus: PropTypes.bool,
  setFocusKey: PropTypes.func,
  changeFocus: PropTypes.func,
  removeFocus: PropTypes.func,
  createRiderColumn: PropTypes.func,
  createRiderItem: PropTypes.func,
  editRiderItem: PropTypes.func,
  deleteRiderItem: PropTypes.func,
  options: PropTypes.array,
  categories: PropTypes.array,
  creatableCategory: PropTypes.bool,
  createStageElement: PropTypes.func,
  searchResults: PropTypes.array,
  getSearchResults: PropTypes.func
}

SelectForm.defaultProps = {
  group: '',
  item: {},
  itemGroups: [],
  position: 0,
  placeholder: null,
  promptTextCreator: null,
  typeSelectorText: null,
  itemGroupingText: null,
  setFocus: false,
  setFocusKey: function() {},
  changeFocus: function() {},
  removeFocus: function() {},
  createRiderColumn: function() {},
  createRiderItem: function() {},
  editRiderItem: function() {},
  deleteRiderItem: function() {},
  options: undefined,
  categories: undefined,
  creatableCategory: false,
  createStageElement: function() {},
  searchResults: undefined,
  getSearchResults: function() {}
}

export default SelectForm



// WEBPACK FOOTER //
// ./src/components/rider/rider-input/select-form.js